// 全局断网提示横幅：offline 事件置顶显示，online 自动消失。
// 断网期间所有请求将以「网络连接异常」失败，横幅提前告知根因，避免用户误判为系统故障。
//
// 注入式下沉（FE2-013 / FE2-003 方案首落地）：admin/agent/merchant 原实现逐字节相同
// （缺省中文文案即其原行为）；customer 原实现仅文案一行走 i18n，由其本地壳解析
// t('errors.network.offlineBanner') 后经 message props 注入——shared 不依赖 react-i18next。
import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

export interface OfflineBannerProps {
  /** 断网提示文案；缺省为 admin/agent/merchant 三端原固定中文文案（多数端现行行为） */
  message?: string;
}

export default function OfflineBanner({ message = '网络连接已断开，请检查网络后重试' }: OfflineBannerProps) {
  const [offline, setOffline] = useState(() =>
    typeof navigator !== 'undefined' ? !navigator.onLine : false);

  useEffect(() => {
    const handleOffline = () => setOffline(true);
    const handleOnline = () => setOffline(false);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!offline) return null;
  return (
    <div
      className="fixed top-0 inset-x-0 z-[100] bg-amber-500 text-white text-sm text-center py-2 px-4 shadow-md"
      role="status"
      aria-live="polite"
    >
      <span className="inline-flex items-center gap-2">
        <WifiOff className="w-4 h-4" />
        {message}
      </span>
    </div>
  );
}
